import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT_INFO } from "../content";

export const Footer = () => (
  <footer className="relative border-t border-white/10 bg-[#05070A]" data-testid="footer">
    <div className="beam-h w-full opacity-40" />
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div>
        <Logo />
        <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
          An internationally recognized firm delivering geospatial and software solutions across the entire geospatial value chain — data creation, conversion, analytics and consulting.
        </p>
      </div>
      <div>
        <h4 className="font-mono-tech text-xs uppercase tracking-[0.25em] text-slate-500 mb-5">Services</h4>
        <ul className="space-y-3 text-sm">
          {["Data Management", "Imagery Services", "Risk Modelling & Analytics", "IT Services", "Engineering Services", "Geospatial Services"].map((s) => (
            <li key={s}>
              <Link to="/services" data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-slate-300 hover:text-cyan-400 transition-colors">
                {s}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-mono-tech text-xs uppercase tracking-[0.25em] text-slate-500 mb-5">Company</h4>
        <ul className="space-y-3 text-sm">
          {[
            ["About Us", "/about"], ["Industries", "/industries"], ["Data Catalog", "/data-catalog"],
            ["Careers", "/careers"], ["Contact", "/contact"],
          ].map(([label, to]) => (
            <li key={to + label}>
              <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="text-slate-300 hover:text-cyan-400 transition-colors">
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-mono-tech text-xs uppercase tracking-[0.25em] text-slate-500 mb-5">Headquarters</h4>
        <div className="space-y-4 text-sm text-slate-300">
          <p className="flex gap-2.5 leading-relaxed">
            <MapPin size={15} className="text-cyan-400 shrink-0 mt-0.5" />
            <span>{CONTACT_INFO.address.slice(2).join(" ")}</span>
          </p>
          <p className="flex gap-2.5 items-center">
            <Phone size={15} className="text-cyan-400 shrink-0" />
            <a href="tel:08842355449" data-testid="footer-phone" className="hover:text-cyan-400 transition-colors font-mono-tech text-xs">{CONTACT_INFO.phones.join("  /  ")}</a>
          </p>
          <p className="flex gap-2.5 items-center">
            <Mail size={15} className="text-cyan-400 shrink-0" />
            <a href={`mailto:${CONTACT_INFO.email}`} data-testid="footer-email" className="hover:text-cyan-400 transition-colors">{CONTACT_INFO.email}</a>
          </p>
          <Link to="/contact" data-testid="footer-cta-link" className="inline-flex items-center gap-1.5 text-cyan-400 font-medium hover:gap-2.5 transition-all">
            Start a project <ArrowUpRight size={15} />
          </Link>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500 font-mono-tech">© {new Date().getFullYear()} DESTINYCS PRIVATE LIMITED — CIN: U74999AP2018PTC108719</p>
        <p className="text-xs text-slate-600 font-mono-tech tracking-widest">MAPPING THE PHYSICAL EARTH</p>
      </div>
    </div>
  </footer>
);
